// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Fredoka_158fa5', '__Fredoka_Fallback_158fa5'","fontStyle":"normal"},"className":"__className_158fa5"};